/*
 * @Author: WangYuzhou
 * @Date: 2023-12-07 20:32:36
 * @LastEditors: WangYuzhou
 * @LastEditTime: 2024-06-28 16:42:24
 * @Description: TODO
 */
// api.js

function buildQueryString (params) {
  const query = new URLSearchParams(params).toString()
  return query ? `?${query}` : ''
}

async function customFetch (
  endpoint,
  { method = 'GET', data = null, params = null, options = {} } = {}
) {
  const headers = {
    Accept: 'application/json',
    ...options
  }
  if (!(data instanceof FormData)) {
    headers['Content-Type'] = 'application/json'
  }
  let url = `https://a.new.tianzenb.com${endpoint}`
  if (endpoint.substring(0, 4) == 'http' || endpoint.substring(0, 2) == '//') {
    url = endpoint
  }

  if (params && method === 'GET') {
    url += buildQueryString(params)
  }

  const config = {
    method,
    headers
  }

  if (data) {
    if (data instanceof FormData) {
      config.body = data
    } else {
      config.body = JSON.stringify(data)
    }
  }

  try {
    const response = await fetch(url, config)

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    let res = await response.json()
    // console.info("----fetch----", url, res);
    return res
  } catch (error) {
    console.error(`Fetch ${method} Error:`, error)
    return error
  }
}

export function get (url, params, options = {}) {
  return customFetch(url, { method: 'GET', params, options })
}

export function post (url, data, options = {}) {
  return customFetch(url, { method: 'POST', data, options })
}
